import React, { useEffect } from 'react';
import { CountdownBar } from '../components/CountdownBar';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { PricingCard } from '../components/PricingCard';
import { FAQSection } from '../components/FAQSection';
import { Check, BookOpen, Brain, Heart, Puzzle, Users, X, ShieldCheck, ArrowRight, Zap, Star } from 'lucide-react';
export function LandingPage() {
  const checkoutUrl = 'https://checkout18.recursospro.shop/cart/47303343603961:1';
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 pb-20" data-id="element-69">
      <CountdownBar data-id="element-70" />
      <PurchasePopup data-id="element-71" />

      {/* HERO SECTION */}
      <header className="pt-10 pb-4 px-4 md:pt-12 md:pb-6 bg-gradient-to-b from-yellow-50 to-white text-center relative overflow-hidden" data-id="element-72">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(251,191,36,0.1),transparent_50%)]" data-id="element-73"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-74">
          <div className="inline-block bg-gradient-to-r from-yellow-400 to-orange-400 text-black font-black px-4 py-1.5 rounded-full text-xs md:text-sm mb-2 shadow-lg animate-pulse" data-id="element-75">
            🔥 OFERTA EXCLUSIVA - 70% DE DESCUENTO HOY 🔥
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-2 tracking-tight" data-id="element-76">
            <span className="text-red-600" data-id="element-77">MEGAPACK</span> INCLUSIVO INFANTIL
          </h1>

          <div className="flex justify-center mb-2" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/38uhu92Qw4eaoejqdBXeKf/PROYECTOS_Anuales_(14).png" alt="MegaPack Inclusivo Infantil - Colección de recursos" className="w-full max-w-[280px] md:max-w-xs drop-shadow-2xl rounded-lg transform hover:scale-105 transition-transform duration-500 cursor-pointer border-4 border-yellow-400" onClick={scrollToPricing} data-id="element-79" />
          </div>

          <p className="text-xl md:text-2xl text-gray-700 font-bold max-w-2xl mx-auto mb-4" data-id="element-80">
            +500 Recursos Profesionales Listos Para Usar{' '}
            <span className="text-green-600" data-id="element-81">✓</span>
          </p>

          <div className="bg-gradient-to-r from-green-50 to-blue-50 border-2 border-green-400 p-4 md:p-5 rounded-xl max-w-3xl mx-auto mb-6 text-center shadow-lg" data-id="element-82">
            <p className="text-sm md:text-base text-gray-800 font-semibold" data-id="element-83">
              🎯 Recursos claros, organizados y adaptados para trabajar
              lenguaje, atención, inclusión y aprendizaje, sin pasar horas
              preparando ni empezar desde cero cada día.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-84">
            <CTAButton onClick={scrollToPricing} className="animate-bounce-subtle shadow-2xl" data-id="element-85">
              👉 SÍ, QUIERO ACCEDER AHORA 👈
            </CTAButton>
            <div className="flex items-center gap-2 text-sm text-gray-600 bg-yellow-100 px-4 py-2 rounded-full border-2 border-yellow-300" data-id="element-86">
              <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-87" />
              <span className="font-bold" data-id="element-88">
                Garantía de satisfacción de 7 días o te devolvemos tu dinero
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gradient-to-b from-red-50 to-white" data-id="element-89">
        <div className="max-w-3xl mx-auto" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-91">
            ❌ Si trabajás con niños,{' '}
            <span className="text-red-600" data-id="element-92">ESTO TE VA A DOLER...</span>
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-4 border-red-200 mb-10" data-id="element-93">
            <p className="text-xl font-bold text-red-600 mb-6" data-id="element-94">
              ¿Te pasa que preparar actividades inclusivas te cansa más que
              aplicarlas?
            </p>
            <p className="text-gray-700 mb-4 font-semibold" data-id="element-95">
              No porque no te importe la inclusión. No porque no tengas
              formación ni vocación.
            </p>
            <p className="text-gray-900 mb-4 font-black text-lg" data-id="element-96">
              Sino porque cada día parece empezar desde cero.
            </p>
            <ul className="space-y-3 mt-6" data-id="element-97">
              {['Buscar actividades y adaptar materiales', 'Pensar variantes para cada necesidad', 'Armar recursos diferentes constantemente', 'Ordenar PDFs, fichas y juegos sueltos'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-red-50 p-3 rounded-lg" data-id="element-98">
                  <X className="w-6 h-6 text-red-600 flex-shrink-0" data-id="element-99" />
                  <span className="text-gray-800 font-semibold" data-id="element-100">{item}</span>
                </li>)}
            </ul>
            <div className="mt-6 text-gray-900 font-bold border-l-4 border-red-600 pl-4 py-3 bg-red-100 rounded-r-lg" data-id="element-101">
              💔 Y cuando finalmente llega el momento de trabajar con los
              chicos… ya estás agotado/a.
            </div>
          </div>

          <div className="text-center bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-2xl shadow-xl" data-id="element-102">
            <p className="text-2xl font-black" data-id="element-103">
              👉 Acompañar la inclusión NO debería sentirse así.
            </p>
          </div>
        </div>
      </section>

      {/* AGITATION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-104">
        <div className="max-w-3xl mx-auto" data-id="element-105">
          <h2 className="text-3xl font-black text-center text-gray-900 mb-4" data-id="element-106">
            😰 El problema que{' '}
            <span className="text-red-600" data-id="element-107">casi nadie dice en voz alta</span>
          </h2>
          <p className="text-center text-gray-600 mb-10 text-lg font-semibold" data-id="element-108">
            Si sos docente, acompañante terapéutico o profesional, esto
            seguramente te resulta familiar:
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-109">
            {['Pasás horas creando materiales desde cero', 'Tenés recursos, pero están desordenados', 'Buscás actividades inclusivas y nunca encontrás todo en un solo lugar', 'Improvisás más de lo que te gustaría', 'Sentís que los chicos necesitan más… y vos no llegás', 'Lo peor es esa sensación constante de: "Podría acompañarlos mejor… si tuviera el material listo."'].map((item, i) => <div key={i} className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-lg border-l-4 border-orange-500 shadow-md hover:shadow-lg transition-shadow" data-id="element-110">
                <p className="text-gray-800 font-bold" data-id="element-111">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-gradient-to-br from-green-600 via-emerald-600 to-teal-600 text-white text-center relative overflow-hidden" data-id="element-112">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(255,255,255,0.1),transparent_50%)]" data-id="element-113"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-114">
          <div className="inline-block bg-yellow-400 text-gray-900 font-black px-6 py-2 rounded-full mb-6 shadow-xl text-lg" data-id="element-115">
            ✅ LA SOLUCIÓN DEFINITIVA
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-6 drop-shadow-lg" data-id="element-116">
            MegaPack Inclusivo Infantil
          </h2>
          <p className="text-xl md:text-2xl font-bold mb-10 max-w-2xl mx-auto drop-shadow-md" data-id="element-117">
            Un sistema completo de recursos inclusivos, diseñado para que dejes
            de improvisar, ganes claridad y recuperes tu tiempo.
          </p>

          <div className="grid md:grid-cols-3 gap-6 text-gray-900 mb-10" data-id="element-118">
            <div className="bg-white p-6 rounded-xl shadow-2xl border-t-4 border-yellow-400 transform hover:scale-105 transition-transform" data-id="element-119">
              <div className="text-5xl mb-4" data-id="element-120">📂</div>
              <h3 className="font-black text-lg mb-2" data-id="element-121">1. Abrís el material</h3>
              <p className="text-sm text-gray-600 font-semibold" data-id="element-122">
                Acceso inmediato a tu biblioteca digital organizada.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-2xl border-t-4 border-orange-400 transform hover:scale-105 transition-transform" data-id="element-123">
              <div className="text-5xl mb-4" data-id="element-124">👆</div>
              <h3 className="font-black text-lg mb-2" data-id="element-125">
                2. Elegís la actividad
              </h3>
              <p className="text-sm text-gray-600 font-semibold" data-id="element-126">
                Encontrás lo que necesitás según el área o necesidad.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-2xl border-t-4 border-green-400 transform hover:scale-105 transition-transform" data-id="element-127">
              <div className="text-5xl mb-4" data-id="element-128">🧩</div>
              <h3 className="font-black text-lg mb-2" data-id="element-129">3. La aplicás</h3>
              <p className="text-sm text-gray-600 font-semibold" data-id="element-130">
                Listo para usar en el aula, consultorio o en casa.
              </p>
            </div>
          </div>

          <p className="text-2xl font-black mb-8 drop-shadow-md" data-id="element-131">
            ⚡ Sin vueltas. Sin improvisar. Sin perder horas. ⚡
          </p>

          <CTAButton onClick={scrollToPricing} className="shadow-2xl" data-id="element-132">
            👉 QUIERO MI MEGAPACK AHORA 👈
          </CTAButton>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-20 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-133">
        <div className="max-w-5xl mx-auto" data-id="element-134">
          <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-6" data-id="element-135">
            🌟 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="text-center mb-12" data-id="element-136">
            <span className="bg-gradient-to-r from-green-500 to-emerald-600 text-white font-black px-6 py-3 rounded-xl text-xl shadow-xl inline-block" data-id="element-137">
              📚 Más de 500 recursos listos para usar
            </span>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-138">
            {/* Category 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-blue-500 hover:shadow-2xl transition-shadow" data-id="element-139">
              <div className="flex items-center gap-3 mb-6" data-id="element-140">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-141">
                  <span className="text-3xl" data-id="element-142">🗣️</span>
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-143">
                  Lenguaje y Comunicación
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-144">
                {['Lectoescritura y grafomotricidad', 'Tarjetas fonéticas y conciencia fonológica', 'Estimulación del vocabulario', 'Terapia de lenguaje infantil', 'Pack Lenguaje para Autismo'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-145">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-146" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-purple-500 hover:shadow-2xl transition-shadow" data-id="element-147">
              <div className="flex items-center gap-3 mb-6" data-id="element-148">
                <div className="bg-purple-100 p-3 rounded-full" data-id="element-149">
                  <span className="text-3xl" data-id="element-150">🎲</span>
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-151">
                  Atención, Conducta y Emociones
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-152">
                {['Actividades para trabajar la atención', 'Juegos de concentración', 'Control de berrinches y enfados', 'Desarrollo emocional y conductual', 'Pack TDA / TDAH'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-153">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-154" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-yellow-500 hover:shadow-2xl transition-shadow" data-id="element-155">
              <div className="flex items-center gap-3 mb-6" data-id="element-156">
                <div className="bg-yellow-100 p-3 rounded-full" data-id="element-157">
                  <span className="text-3xl" data-id="element-158">🌈</span>
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-159">
                  Inclusión y Necesidades Especiales
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-160">
                {['Actividades para niños con TEA', 'Síndrome de Down', 'Dislexia y dificultades visuales/auditivas', 'Sordoceguera y limitaciones motrices', 'Material en Braille y accesibilidad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-161">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-162" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-pink-500 hover:shadow-2xl transition-shadow" data-id="element-163">
              <div className="flex items-center gap-3 mb-6" data-id="element-164">
                <div className="bg-pink-100 p-3 rounded-full" data-id="element-165">
                  <span className="text-3xl" data-id="element-166">🎨</span>
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-167">
                  Juegos y Recursos Creativos
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-168">
                {['Pictogramas y juegos inclusivos', 'Actividades lúdicas', 'Cuadernos prácticos', 'Material artístico y de expresión', 'Todo organizado en carpetas digitales'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-169">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-170" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-171">
        <div className="max-w-4xl mx-auto" data-id="element-172">
          <h2 className="text-3xl font-black text-center mb-10" data-id="element-173">
            ⚡ Antes vs Después ⚡
          </h2>
          <div className="grid md:grid-cols-2 gap-0 md:gap-8" data-id="element-174">
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-t-2xl md:rounded-2xl border-4 border-red-300 shadow-xl" data-id="element-175">
              <h3 className="text-xl font-black text-red-700 mb-6 flex items-center gap-2" data-id="element-176">
                <X className="w-6 h-6" data-id="element-177" /> Antes del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-178">
                {['Improvisación constante', 'Cansancio mental', 'Falta de materiales adaptados', 'Estrés diario', 'Poco tiempo para los chicos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 font-bold" data-id="element-179">
                    <X className="w-5 h-5 text-red-600" data-id="element-180" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-100 p-8 rounded-b-2xl md:rounded-2xl border-4 border-green-400 shadow-xl relative overflow-hidden" data-id="element-181">
              <div className="absolute top-0 right-0 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-182">
                ✨ TU NUEVA REALIDAD
              </div>
              <h3 className="text-xl font-black text-green-700 mb-6 flex items-center gap-2" data-id="element-183">
                <Check className="w-6 h-6" data-id="element-184" /> Después del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-185">
                {['Actividades claras y progresivas', 'Material listo siempre', 'Inclusión real y organizada', 'Más confianza', 'Más disfrute al enseñar'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 font-bold" data-id="element-186">
                    <Check className="w-5 h-5 text-green-600" data-id="element-187" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white relative overflow-hidden" data-id="element-188">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(168,85,247,0.2),transparent_70%)]" data-id="element-189"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-190">
          <div className="text-center mb-12" data-id="element-191">
            <span className="text-yellow-400 font-black tracking-widest uppercase text-sm mb-2 block animate-pulse" data-id="element-192">
              🎁 SOLO POR HOY 🎁
            </span>
            <h2 className="text-3xl md:text-5xl font-black mb-4 drop-shadow-lg" data-id="element-193">
              Regalos especiales –{' '}
              <span className="text-yellow-400" data-id="element-194">GRATIS HOY</span>
            </h2>
            <p className="text-gray-300 text-lg font-bold" data-id="element-195">
              Al ordenar hoy, te llevás estos 3 bonos exclusivos sin costo
              adicional.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-196">
            <BonusCard title="Bono #1: +98 Libros para Colorear" description={['Animales, frutas, objetos y mandalas', 'Atención y motricidad fina', 'Listos para imprimir']} imageSrc="https://cdn.magicpatterns.com/uploads/kKcUc7dWyLVVc1LAqVNPXp/PROYECTOS_Anuales_(15).png" data-id="element-197" />
            <BonusCard title="Bono #2: Mini Pack Atención" description={['Juegos cortos (5–10 minutos)', 'Ideal para pausas activas', 'Para aula y hogar']} imageSrc="https://cdn.magicpatterns.com/uploads/aYTvDJ626XcM7NXEVHKbsJ/PROYECTOS_Anuales_(16).png" data-id="element-198" />
            <BonusCard title="Bono #3: Guía Control Emociones" description={['Consejos prácticos', 'Actividades rápidas', 'Ideal para docentes y familias']} imageSrc="https://cdn.magicpatterns.com/uploads/rivseEtD5m5kimjU7KSD32/PROYECTOS_Anuales_(17).png" data-id="element-199" />
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-yellow-50 via-orange-50 to-white" data-id="element-200">
        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-201">
          <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-full mb-4 animate-pulse shadow-xl" data-id="element-202">
            ⏰ OFERTA EXPIRA HOY ⏰
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-203">
            Oferta por <span className="text-red-600" data-id="element-204">tiempo limitado</span>
          </h2>
          <p className="text-xl text-gray-700 font-bold" data-id="element-205">
            Todo lo que necesitás para potenciar la inclusión, a una fracción de
            su valor real.
          </p>
        </div>

        <PricingCard data-id="element-206" />

        <div className="max-w-2xl mx-auto mt-12 bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border-4 border-green-400 shadow-2xl flex flex-col md:flex-row items-center gap-6" data-id="element-207">
          <div className="bg-yellow-400 p-4 rounded-full flex-shrink-0 shadow-lg" data-id="element-208">
            <ShieldCheck className="w-10 h-10 text-green-700" data-id="element-209" />
          </div>
          <div className="text-center md:text-left" data-id="element-210">
            <h3 className="font-black text-lg text-gray-900 mb-1" data-id="element-211">
              🛡️ Garantía sin riesgo
            </h3>
            <p className="text-gray-800 font-bold" data-id="element-212">
              Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
              del dinero. Sin preguntas. Sin letra chica.
            </p>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-213">
          <CTAButton onClick={scrollToPricing} className="shadow-2xl" data-id="element-214">
            🔥 QUIERO MI DESCUENTO DEL 70% AHORA 🔥
          </CTAButton>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gradient-to-b from-white to-gray-50" data-id="element-215">
        <div className="max-w-6xl mx-auto" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-4" data-id="element-217">
            ⭐ Lo que dicen otros profesionales ⭐
          </h2>
          <p className="text-center text-gray-600 font-bold mb-12" data-id="element-218">
            Más de 1,000 profesionales ya confían en nosotros
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-219">
            <TestimonialCard name="Laura Fernández" location="Buenos Aires" quote="Me ahorra horas de preparación. Ahora tengo todo listo y adaptado para mis alumnos." data-id="element-220" />
            <TestimonialCard name="Agustina Godoy" location="Santa Fe" quote="Antes improvisaba, hoy trabajo con seguridad y materiales de calidad." data-id="element-221" />
            <TestimonialCard name="María Fucchili" location="Córdoba" quote="Volví a disfrutar mis clases porque sé que siempre tengo recursos adecuados a cada necesidad." data-id="element-222" />
            <TestimonialCard name="Carla Méndez" location="Mendoza" quote="Increíble la cantidad de recursos. Lo uso tanto en el consultorio como para recomendar actividades a los padres." data-id="element-223" />
            <TestimonialCard name="Sofía Ramírez" location="Tucumán" quote="La organización por carpetas es excelente. Encuentro lo que necesito en segundos. ¡Súper recomendado!" data-id="element-224" />
          </div>

          <div className="text-center mt-10" data-id="element-225">
            <CTAButton onClick={scrollToPricing} data-id="element-226">
              👉 QUIERO UNIRME A ELLAS AHORA 👈
            </CTAButton>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-227">
        <div className="max-w-3xl mx-auto" data-id="element-228">
          <h2 className="text-3xl font-black text-center text-gray-900 mb-10" data-id="element-229">
            ❓ Preguntas frecuentes
          </h2>
          <FAQSection data-id="element-230" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gradient-to-br from-gray-900 to-black text-gray-400 py-12 px-4 text-center" data-id="element-231">
        <div className="max-w-4xl mx-auto" data-id="element-232">
          <div className="mb-8" data-id="element-233">
            <h3 className="text-2xl font-black text-white mb-4" data-id="element-234">
              🌟 La inclusión puede ser más simple
            </h3>
            <p className="mb-6 font-bold text-gray-300" data-id="element-235">
              No necesitás más esfuerzo. Necesitás un sistema que te sostenga.
            </p>
            <CTAButton onClick={scrollToPricing} className="text-lg py-4 px-10 shadow-2xl" data-id="element-236">
              🚀 ACCEDÉ AHORA AL MEGAPACK 🚀
            </CTAButton>
          </div>

          <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-237">
            <p className="mb-2 font-semibold" data-id="element-238">
              © 2026 MegaPack Inclusivo Infantil – Todos los derechos
              reservados
            </p>
            <div className="flex justify-center gap-4" data-id="element-239">
              <span data-id="element-240">Privacidad</span>
              <span data-id="element-241">·</span>
              <span data-id="element-242">Términos y Condiciones</span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}